export default {
  user:{},
  title:"Associação dos Criadores de Gado Jersey do Brasil",
  image:"@/assets/logo.png",
  headers:{}
}
